import { QueryClient } from 'react-query';
import { QueryConfigTypes } from '../../apis-infra';
import { QUERY_CONFIGS } from './queryConfigTypes';
import { getSharedPremiumResource } from '../../premium-api/getSharedPremiumResource';
import { PremiumSharedResource } from '../../premium-api/types';

/**
 * @param params:
 * @param configType: REALTIME / DYNAMIC / STATIC / FIXED according to the change frequency of the data
 * @param options: (optional) other react-query client options
 */
export const createQueryClient = params => {
  var _params$options, _params$options$defau, _params$options2, _params$options2$defa;
  return new QueryClient({
    defaultOptions: {
      queries: {
        suspense: false,
        meta: {},
        ...(params == null ? void 0 : (_params$options = params.options) == null ? void 0 : (_params$options$defau = _params$options.defaultOptions) == null ? void 0 : _params$options$defau.queries),
        ...QUERY_CONFIGS[QueryConfigTypes.DYNAMIC_DATA],
        // 30sec is the maximal value allowed
        retryDelay: 30000,
        retryOnMount: false,
        retry: false,
        refetchIntervalInBackground: false,
        refetchInterval: false,
        ...(params != null && params.configType ? QUERY_CONFIGS[params == null ? void 0 : params.configType] : {})
      },
      mutations: {
        ...(params == null ? void 0 : (_params$options2 = params.options) == null ? void 0 : (_params$options2$defa = _params$options2.defaultOptions) == null ? void 0 : _params$options2$defa.mutations),
        retryDelay: 30000,
        retry: false
      }
    },
    ...(params == null ? void 0 : params.options)
  });
};
export const getSharedQueryClient = () => {
  return getSharedPremiumResource(PremiumSharedResource.QueryClientInstance, createQueryClient);
};
export function setQueryClientDefaultQueryOptions(optionsOrModifier) {
  const queryClient = getSharedQueryClient();
  const defaultOptions = queryClient.getDefaultOptions();
  const prevValues = {
    ...defaultOptions.queries
  };
  const modifier = typeof optionsOrModifier === 'function' ? optionsOrModifier : () => optionsOrModifier;
  const newOptions = modifier(prevValues);
  queryClient.setDefaultOptions({
    ...defaultOptions,
    queries: {
      ...defaultOptions.queries,
      ...newOptions
    }
  });
  return prevValues;
}
export const getQueryClientDefaultQueryOptions = () => {
  const queryClient = getSharedQueryClient();
  return {
    ...queryClient.getDefaultOptions().queries
  };
};
//# sourceMappingURL=queryClientInstance.js.map